import { lazy, Suspense } from "react"; 

// specialists data
import specialists from "./data/specialists.json";

import HeroSection from "./HeroSection";

const SpecialistsSection = lazy(() => import("./SpecialistsSection"));
const PlaySection = lazy(() => import("./PlaySection"));
const ImageSection = lazy(() => import("./ImageSection"));

const PeopleOfLentera = () => {
  const row1 = specialists.slice(0, 5);
  const row2 = specialists.slice(5, 10);

  return (
    <>
      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <SpecialistsSection row1={row1} row2={row2} />
        <PlaySection />
        <ImageSection />
      </Suspense>
    </>
  );
};

export default PeopleOfLentera;
